// @flow
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withTranslation, WithTranslation, Trans } from 'react-i18next';
import moment from 'moment';

import publicApiService from '../../services/public-api-service';
import Loader from '../shared/Loader';
import PublicView from '../layouts/PublicView';
import Message from '../shared/Message';
import Icon from '../shared/Icon';
import Text from '../shared/Typography';

type Props = {
  match: {
    params: {
      user_token: string
    }
  },
  history: Object,
  location?: {
    search?: string
  }
} & WithTranslation

type State = {
  error: string,
  passport: {
    first_name: string,
    last_name: string,
    completion_date: string,
    total_doses: string,
    vaccine_name: string,
    location: string,
    verified_date: string
  },
  loading: boolean
};

class UserPassport extends Component {
  props: Props;
  state: State;

  state = {
    error: '',
    passport: null,
    loading: true
  };

  componentDidMount() {
    publicApiService.get(`/public/vaccines/covid19/passport/validate${this.props.location.search}`).then((response) => {
      this.setState({ passport: response.passport, loading: false });
    }).catch((error) => {
      this.setState({ error, loading: false });
    });
  }

  passportField = ({ head, children }) => {
    if (head) {
      return (
        <Text h2 lowercase className='passport-field'>
          {children}
        </Text>
      );
    }
    return (
      <Text small lowercase className='passport-field'>
        {children}
      </Text>
    );
  }

  passportBody = () => {
    if (!this.state.passport) return null;
    const {
      first_name: firstName,
      last_name: lastName,
      completion_date: completionDate,
      total_doses: totalDoses,
      vaccine_name: vaccineName,
      location,
      verified_date: verifiedDate
    } = this.state.passport;
    const { t } = this.props;
    return (
      <div className='passport-container'>
        <Icon name='check-success' size='x-large' />
        <this.passportField head>
          <Trans
            i18nKey='covid_vaccination'
            t={t}
            values={{ fname: firstName, lname: lastName }}
            components={[<br />]}
          />
        </this.passportField>
        <this.passportField>
          {t('vaccination_completed_on', { date: moment(completionDate).format('lll') })}
        </this.passportField>
        <this.passportField>
          {t('received_doses_at', { totalDoses, vaccineName, location })}
        </this.passportField>
        <this.passportField>
          <span className='passport-field__split-container'>
            <span>
              <Trans
                i18nKey='vaccination_verified_on'
                t={t}
                values={{ date: moment(verifiedDate).format('lll') }}
                components={[<Text altLink href='https://www.dothealth.ca/' />]}
              />
            </span>
            <span>
              <Icon name='lock-gold-closed' size='medium' align='right' />
            </span>
          </span>
        </this.passportField>
      </div>
    );
  }

  render() {
    if (this.state.error) {
      const { t } = this.props;
      return (
        <PublicView className='passport-container' viewType='public-body'>
          <div className='mb2'>
            <Message className='danger'>
              {t('passport_load_fail')}
            </Message>
          </div>
          <this.passportBody />
        </PublicView>
      );
    } else if (this.state.loading) {
      return (
        <PublicView className='passport-container' viewType='public-body'>
          <Loader />
        </PublicView>
      );
    } else if (this.state.passport) {
      return (
        <PublicView viewType='public-body' isLeft>
          <this.passportBody />
        </PublicView>
      );
    }
    return null;
  }
}

const mapStateToProps = () => ({});
const mapDispatchToProps = () => ({});

export default withTranslation('userPassport')(
  connect(mapStateToProps, mapDispatchToProps)(UserPassport)
);



// WEBPACK FOOTER //
// ./src/components/pages/user-passport.js